/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { PipelineStageShowPathParams, PipelineStageShowResponse } from '../types/PipelineStageShow'

/**
 * GET /campaigns/:campaign/pipeline-stages
 * @see backend/nexus/modules/Campaign/Http/Controllers/PipelineStageController.php PipelineStageController::show
 */
export async function pipelineStageShow(
	campaign: PipelineStageShowPathParams['campaign'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<PipelineStageShowResponse>> {
	return axiosInstance.get(`/campaigns/${campaign}/pipeline-stages`, config)
}
